/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Presentation_Template_Created_From_MasterInputs */



/**
* | output |
* | --- |
* | "“{name}” created from your template — {count} layouts detected." |
*
* @param {Presentation_Template_Created_From_MasterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_created_from_master = /** @type {((inputs: Presentation_Template_Created_From_MasterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Created_From_MasterInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`„${i?.name}“ aus Ihrer Vorlage erstellt – ${i?.count} Layouts erkannt.`)
	return /** @type {LocalizedString} */ (`“${i?.name}” created from your template — ${i?.count} layouts detected.`)
});